import React, { useState, lazy, Component } from 'react';
import { Plus, Minus, CheckCircle2 } from 'lucide-react';
const benefits = [{
  emoji: '💰',
  text: 'Sabes cuánto va a costar antes de comprometerte. Un presupuesto real. Sin cifras que se multiplican sin razón a mitad de camino.'
}, {
  emoji: '🛡️',
  text: 'Hay alguien cuidando tu plata dentro de la obra. Cualquier cambio se revisa, se justifica y tú lo apruebas. No pagas sorpresas.'
}, {
  emoji: '⏰',
  text: 'No tienes que estar pendiente de cada detalle. Nosotros manejamos el día a día. Tú te enfocas en lo tuyo.'
}, {
  emoji: '📸',
  text: 'Sabes cómo va tu obra aunque no estés presente. Fotos y avances en cada etapa. Siempre informado, nunca abrumado.'
}, {
  emoji: '✅',
  text: 'El resultado final es lo que acordamos. No lo que fue más fácil de hacer. Lo que tú querías desde el comienzo.'
}, {
  emoji: '🎁',
  text: 'La asesoría no te cuesta nada si contratas la obra. El valor se descuenta del total. El riesgo de empezar es cero.'
}, {
  emoji: '⚡',
  text: 'Tu espacio listo antes — menos tiempo perdiendo plata. Un plan claro desde el día uno hace que todo avance sin pausas innecesarias.'
}, {
  emoji: '🎨',
  text: 'Eliges los acabados con orientación, no a ciegas. Te mostramos qué funciona para tu espacio antes de comprar cualquier cosa.'
}, {
  emoji: '🤝',
  text: 'Un equipo que puede acompañarte en proyectos futuros. Cuando necesites algo más grande, ya tienes un equipo de confianza que conoce tu forma de trabajar.'
}];
const guarantees = [{
  emoji: '🔒',
  question: '¿Qué pasa si hay un cambio en el presupuesto?',
  answer: 'Te informamos de inmediato. Te explicamos el porqué técnico y tú apruebas cualquier ajuste. Sin cobros sorpresa al final.'
}, {
  emoji: '⏱️',
  question: '¿Realmente cumplen las fechas?',
  answer: 'Es nuestro pilar. Planeamos antes de demoler para que los tiempos sean reales, no promesas falsas.'
}];
export function FAQSection() {
  const handleHablarWhatsApp = () => {
    const message = encodeURIComponent('Hola, ¡Quiero Hablar con el equipo!');
    window.open(`https://wa.me/573182434499?text=${message}`, '_blank');
  };
  const handleAgendarWhatsApp = () => {
    const message = encodeURIComponent('Hola, AGENDAR ASESORÍA - 35% OFF');
    window.open(`https://wa.me/573182434499?text=${message}`, '_blank');
  };
  return <section className="bg-[#1A1A1A] py-12 md:py-20" style={{
    contentVisibility: 'auto'
  }} data-id="element-13">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6" data-id="element-14">
        {/* Title above team image */}
        <div className="text-center mb-6 md:mb-8" data-id="element-15">
          <h2 className="text-[26px] md:text-[40px] font-bold text-white" style={{
          lineHeight: '1.2',
          letterSpacing: '-0.02em'
        }} data-id="element-16">
            Nuestro equipo brinda garantías
          </h2>
        </div>

        {/* Team Image */}
        <div className="mb-8 md:mb-12" data-id="element-17">
          <img src="https://cdn.magicpatterns.com/uploads/pqnx8T43t6hPHnL2qToMjC/Gerfaj_-_Equipo.jpg" alt="Equipo GERFAJ" className="w-full h-auto object-cover rounded-2xl md:rounded-3xl" width="1280" height="720" loading="lazy" decoding="async" data-id="element-18" />
        </div>

        {/* Guarantees Section */}
        <div className="max-w-3xl mx-auto mb-8 md:mb-12 space-y-6" data-id="element-19">
          {guarantees.map((guarantee, index) => <div key={index} className="bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8" data-id="element-20">
              <div className="flex items-start gap-4 mb-4" data-id="element-21">
                <span className="text-3xl md:text-4xl flex-shrink-0" data-id="element-22">
                  {guarantee.emoji}
                </span>
                <div data-id="element-23">
                  <h3 className="text-[20px] md:text-[28px] font-semibold text-white mb-2" style={{
                lineHeight: '1.3'
              }} data-id="element-24">
                    {guarantee.question}
                  </h3>
                  <p className="text-[15px] md:text-[17px] text-white/80 font-normal" style={{
                lineHeight: '1.6'
              }} data-id="element-25">
                    {guarantee.answer}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        {/* Button after guarantees - full width on mobile */}
        <div className="text-center mb-12 md:mb-16" data-id="element-26">
          <button onClick={handleHablarWhatsApp} className="w-full md:w-auto bg-[#E8621A] text-white px-8 md:px-12 py-4 md:py-4 rounded-full font-bold uppercase text-[13px] md:text-[15px] hover:bg-[#d55515] transition-all shadow-xl hover:scale-105 min-h-[52px]" style={{
          lineHeight: '1',
          letterSpacing: '0.08em'
        }} data-id="element-27">
            ¡Quiero Hablar con el equipo!
          </button>
        </div>

        {/* Main title */}
        <div className="text-center mb-8 md:mb-16" data-id="element-28">
          <h2 className="text-[26px] md:text-[40px] font-bold text-white mb-4" style={{
          lineHeight: '1.2',
          letterSpacing: '-0.02em'
        }} data-id="element-29">
            Lo que cambia cuando trabajas con nosotros.
          </h2>
        </div>

        {/* Benefits list */}
        <div className="max-w-4xl mx-auto space-y-6 mb-8 md:mb-16" data-id="element-30">
          {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-4" data-id="element-31">
              <span className="text-3xl md:text-4xl flex-shrink-0" data-id="element-32">
                {benefit.emoji}
              </span>
              <p className="text-[15px] md:text-[17px] text-white/80 font-normal" style={{
            lineHeight: '1.6'
          }} data-id="element-33">
                {benefit.text}
              </p>
            </div>)}
        </div>

        {/* Final button - full width on mobile */}
        <div className="text-center" data-id="element-34">
          <button onClick={handleAgendarWhatsApp} className="w-full md:w-auto bg-[#E8621A] text-white px-8 md:px-12 py-4 md:py-4 rounded-full font-bold uppercase text-[13px] md:text-[15px] hover:bg-[#d55515] transition-all shadow-xl hover:scale-105 min-h-[52px]" style={{
          lineHeight: '1',
          letterSpacing: '0.08em'
        }} data-id="element-35">
            AGENDAR ASESORÍA - 35% OFF
          </button>
        </div>
      </div>
    </section>;
}